export var MethodType = {
    email: 'email',
    screen: 'screen',
};
export var StatusType = {
    audit: 'audit',
    reject: 'reject',
};
export var NotificationType = {
    system: 'system',
    request: 'request',
};
export var NotificationCodeType = {
    google: 'google',
    creative: 'creative',
    budget: 'budget',
};
export var PageNo = 1;
export var PageSize = 20;
